import styled from "styled-components";
import {GameJackpotBarContributionLabelDefaultBox} from "./game-jackpot-bar-contribution-label.default.box";
import {baseColors} from "../../../../../../themes/definitions/mrgreen/base-colors";

export const GameJackpotBarContributionLabelMrgreenBox = styled(GameJackpotBarContributionLabelDefaultBox)<{isOptInStatus?: boolean}>`
    color: ${({theme, isOptInStatus}) => isOptInStatus ? theme.colors.textContrast : baseColors.base03Dark};

    @media ${({theme}) => theme.mediaQuery.mAndAbove} {
        font-size: 1.3rem;
    }
`;